export default __webpack_public_path__ + "static/media/profile.763b780d.svg";